module.exports = __webpack_public_path__ + "static/media/peppermint_tobacco.8569188a.png";